import {Box, Grid, Typography} from '@mui/material';
import React from 'react';
import './StyleClusterTooltip.scss';
import {t} from 'i18next';
import {IChild, ICluster} from './TypesHeatMap';

interface IClusterTooltip {
  clusterData: IChild;
}

interface ITooltipField {
  key: string;
  label: string;
}
const tooltipFields: ITooltipField[] = [
  {
    key: 'name',
    label: t(
      'reports.dataAnalysisReport.conceptExplorer.clusterTooltip.clusterShortName'
    ),
  },
  {
    key: 'full',
    label: t(
      'reports.dataAnalysisReport.conceptExplorer.clusterTooltip.fullName'
    ),
  },
  {
    key: 'size',
    label: t(
      'reports.dataAnalysisReport.conceptExplorer.clusterTooltip.totalDocs'
    ),
  },
  {
    key: 'hdocs',
    label: t(
      'reports.dataAnalysisReport.conceptExplorer.clusterTooltip.highlightedDocs'
    ),
  },
];

const ClusterTooltip = ({clusterData}: IClusterTooltip) => {
  return (
    <Box className="cluster-tooltip-container">
      <Typography
        className="typo-text label3_size"
        data-testid={`cluster-tooltip-title`}
      >
        {t('reports.dataAnalysisReport.conceptExplorer.clusterTooltip.title', {
          clusterId: clusterData.id,
        })}
      </Typography>
      <Grid container className="tooltip-content" data-testid="tooltip-content">
        {tooltipFields.map((field: ITooltipField) => (
          <Grid
            container
            key={field.key}
            direction={'row'}
            className="tooltip-row"
          >
            <Grid size={5}>
              <Typography
                className="typo-text label3_size"
                data-testid={`cluster-tooltip-field-label-${field.key}`}
              >
                {field.label}
              </Typography>
            </Grid>
            <Grid size={7}>
              <Typography
                className="typo-text label3_size"
                data-testid={`cluster-tooltip-typography-text-${field.key}`}
              >
                {clusterData[field.key as keyof typeof clusterData] || 'N/A'}
              </Typography>
            </Grid>
          </Grid>
        ))}
        {clusterData?.topNClustersByVolume?.length > 0 && (
          <>
            <Grid container direction={'row'} className="tooltip-row">
              <Grid size={5}>
                <Typography
                  className="typo-text label3_size"
                  data-testid={`cluster-tooltip-total-sub-clusters`}
                >
                  {t(
                    'reports.dataAnalysisReport.conceptExplorer.clusterTooltip.totalSubClusters'
                  )}
                </Typography>
              </Grid>
              <Grid size={7}>
                <Typography
                  className="typo-text label3_size"
                  data-testid={`cluster-tooltip-child-count`}
                >
                  {clusterData.childcount}
                </Typography>
              </Grid>
            </Grid>
            {clusterData?.topNClustersByVolume.map((item: ICluster, index) => (
              <Grid
                key={item.clusterId}
                container
                direction={'row'}
                className="tooltip-row"
              >
                <Grid size={5}>
                  <Typography
                    className="typo-text label3_size"
                    data-testid={`cluster-tooltip-sub-cluster-id-${index}`}
                  >
                    {t(
                      'reports.dataAnalysisReport.conceptExplorer.clusterTooltip.subClusterId',
                      {subClusterId: item.clusterId}
                    )}
                  </Typography>
                </Grid>
                <Grid size={7}>
                  <Typography
                    className="typo-text label3_size"
                    data-testid={`cluster-tooltip-sub-cluster-name-${index}`}
                  >
                    {item.clusterFullName}
                  </Typography>
                </Grid>
              </Grid>
            ))}
            <Typography
              className="typo-text body4_size"
              data-testid={`cluster-tooltip-note`}
            >
              {t(
                'reports.dataAnalysisReport.conceptExplorer.clusterTooltip.note',
                {
                  level: '2nd',
                }
              )}
            </Typography>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default ClusterTooltip;
